import { Switch as MuiSwitch } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useState } from 'react'

const Android12Switch = styled(MuiSwitch)(() => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16
    },
    '&:before': {
      // backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
      //   theme.palette.getContrastText(theme.palette.primary.main)
      // )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12
    },
    '&:after': {
      // backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
      //   theme.palette.getContrastText(theme.palette.primary.main)
      // )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12
    }
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& + .MuiSwitch-track': {
        backgroundColor: '#023770',
        opacity: 1,
        border: 0
      }
    }
  },
  '& .MuiSwitch-thumb': {
    background: '#fff',
    width: 18,
    height: 18,
    margin: 1
  }
}))

interface SwitchProps {
  checked?: boolean
  onChange: any
  label?: string
}

export const Switch = (props: SwitchProps) => {
  const { checked, onChange, label } = props
  const [_checked, setChecked] = useState<boolean>(checked || false)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        cursor: 'pointer'
      }}
      onClick={() => setChecked((prev) => !prev)}
    >
      <Android12Switch checked={_checked} onChange={onChange} />
      <div className="select-none">{label}</div>
    </div>
  )
}

Switch.defaultProps = {
  checked: false,
  label: ''
}
